import { render } from "./PaypalPage.vue?vue&type=template&id=21c0d3bc&scoped=true"
import script from "./PaypalPage.vue?vue&type=script&lang=js"
export * from "./PaypalPage.vue?vue&type=script&lang=js"

import "./PaypalPage.vue?vue&type=style&index=0&id=21c0d3bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c0d3bc"]])

export default __exports__